// ./src/components/generic/LoadingOverlay/LoadingOverlay.tsx
import React from "react";
import { Overlay, Center, Stack, Text } from "@mantine/core";
import { LoadingIndicator, LoadingIndicatorProps } from "../LoadingIndicator";
import { Logo } from "../Logo";

export interface LoadingOverlayProps {
  /** Whether the overlay is visible */
  visible: boolean;

  /** Optional text to display below the loading indicator */
  loadingText?: string;

  /** Blur amount for the backdrop */
  blur?: number;

  /** Z-index for the overlay */
  zIndex?: number;

  /** Props for the loading indicator */
  loaderProps?: Partial<LoadingIndicatorProps>;

  /** Additional className for styling */
  className?: string;

  /** Additional styles */
  style?: React.CSSProperties;

  showVersion?: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  visible,
  loadingText,
  blur = 2,
  zIndex = 200,
  loaderProps = {},
  className,
  style,
  showVersion = true,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <Overlay
      color="#fff"
      opacity={0.75}
      blur={blur}
      zIndex={zIndex}
      {...(className && { className })}
      {...(style && { style })}
    >
      <Center h="100%">
        <Stack align="center" gap="md">
          <Logo size="large" />
          <LoadingIndicator size="lg" {...loaderProps} />
          {loadingText && (
            <Text size="md" c="dimmed" ta="center">
              {loadingText}
            </Text>
          )}
          {showVersion && (
            <Text size="sm" c="dimmed" ta="center">
              Version {import.meta.env.VITE_APP_VERSION}
            </Text>
          )}
        </Stack>
      </Center>
    </Overlay>
  );
};
